import React from "react";
import Rating from "../atoms/Rating";
import Modal, { ModalProps } from "../atoms/Modal";

interface RatingModalProps extends Omit<ModalProps, "children"> {}

const RatingModal: React.FC<RatingModalProps> = ({
  isOpen,
  onRequestClose,
}) => {
  const handleRatingChange = (rating: number) => {
    console.log(`Selected rating: ${rating}`);
  };

  const headding = "How would you rate your experience?";
  const cancelText = "No, thanks.";

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <div id="rating-modal" className="rating-modal">
        <div className="modal-header"></div>
        <div className="modal-body">
          <h1 className="mb-20 rating-modal-heading">{headding}</h1>
          <Rating maxStars={5} onRatingChange={handleRatingChange} />
          <form className="rating-form">
            <textarea rows={8} className="mb-20"></textarea>
            <input
              type="submit"
              value="Submit rating"
              className="rating-submit-button w-100 mb-20"
            />
          </form>
          <a
            onClick={onRequestClose}
            className="cancel-rating"
            style={{ cursor: "pointer" }}
          >
            {cancelText}
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default RatingModal;
